export default "__VITE_ASSET__DBDOLseK__"